import { getAppI18nConfig, initI18n } from 'cfgi18n';
import { GetServerSideProps } from 'next';

import {
	getFooter,
	getMainNav,
	getPartnerLogos,
} from 'services/mancity-template';
import { GetFooterResponse } from 'services/mancity-template/get/types/get-footer.type';
import { GetMainNavResponse } from 'services/mancity-template/get/types/get-main-nav.type';
import { GetPartnerLogosResponse } from 'services/mancity-template/get/types/get-partner-logos.type';
import { getPlayers, GetPlayersResponse } from 'services/players';

import { Seo } from 'core/mancity/components/general/seo';

import { LandingLayout } from '../layouts/landing';

export type IndexProps = {
	playersData: GetPlayersResponse;
	footerData?: GetFooterResponse;
	mainNavData?: GetMainNavResponse;
	partnersData?: GetPartnerLogosResponse;
};

export default function Index({ playersData }: IndexProps) {
	return (
		<>
			{playersData.head && <Seo head={playersData.head} />}
			<LandingLayout team={'mens'} data={playersData} />
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { fromapp } = context.query;
	const isFromApp = typeof fromapp !== 'undefined';
	const locale = context.locale as string;

	let footerData: GetFooterResponse | undefined;
	let mainNavData: GetMainNavResponse | undefined;
	let partnersData: GetPartnerLogosResponse | undefined;

	const { supportedLocales } = await getAppI18nConfig('players');
	await initI18n(locale, supportedLocales);

	const response = await getPlayers('mens', locale);

	if (!isFromApp) {
		footerData = await getFooter(locale).then((response) => response.data);
		mainNavData = await getMainNav(locale).then(
			(response) => response.data
		);
		partnersData = await getPartnerLogos(locale).then(
			(response) => response.data
		);
	}

	if (!response.data || !response.data.body.length) {
		return {
			notFound: true,
		};
	}

	return {
		props: {
			playersData: response.data,
			footerData,
			mainNavData,
			partnersData,
			locale,
		},
	};
};
